import { useSelector } from 'react-redux';
import LeadParams from 'types/Apis/LeadParams';
import State from 'types/State';

export default function useLeadSubmissions(): LeadParams[] {
  return useSelector<State, LeadParams[]>((state) => state.leadSubmissions);
}
